import { render, staticRenderFns } from "./UserTabClassAdd.vue?vue&type=template&id=36ffbbf6&"
import script from "./UserTabClassAdd.vue?vue&type=script&lang=js&"
export * from "./UserTabClassAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports